/**
 * Numeric primitives. LAYER 0 — pure functions, ZERO project imports.
 *
 * Nothing in here may import from `types`, `db`, `services`, `components` or
 * `pages`. That is the whole contract: every layer above is free to use these
 * without thinking about direction.
 */

/**
 * Round to millisecond precision (3 decimals).
 *
 * Every timestamp the app stores goes through this. Audio offsets arrive from
 * decoders, aligners and the model as full-precision floats, and writing them
 * raw produces rows like `endSec: 1.2300000000000002` that no longer compare
 * equal to the neighbour's `startSec` — which is exactly the equality the
 * partition invariant is checked with. A millisecond is also finer than any
 * boundary a human can hear or place, so nothing real is lost.
 *
 * There were TWELVE private copies of this function across services/ before the
 * restructure; this is the one.
 */
export function round3(n: number): number {
  return Math.round(n * 1000) / 1000;
}

/** Constrain `v` to the inclusive range [`lo`, `hi`]. */
export function clamp(v: number, lo: number, hi: number): number {
  return v < lo ? lo : v > hi ? hi : v;
}
